import { useNavigate } from "react-router-dom";
import favicon from '../assets/images/favicon.png';
import orange_and_black_new from '../assets/images/orange-and-black-new.png';
import HeaderMenu from "./sidebar/headermenu";

export default function VideoKycPending() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 py-6 flex flex-col">
            <HeaderMenu />
            <main className="flex-1 flex flex-col items-center justify-center">
                <div className="w-full">
                    <div className="main__inner max-w-xl mx-auto px-4">

                        {/* Pending Alert Card */}
                        <div className="bg-white rounded-2xl shadow-sm border border-amber-200/80 p-6 md:p-8 text-center relative overflow-hidden">
                            
                            {/* Decorative Accent Bar */}
                            <div className="absolute top-0 left-0 right-0 h-1.5 bg-amber-500"></div>

                            {/* Warning / Pending Icon */}
                            <div className="w-16 h-16 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-5 shadow-inner">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>

                            {/* Alert Headline */}
                            <h2 className="text-xl font-extrabold text-slate-800 mb-2">
                                Your Video KYC is Pending
                            </h2>

                            {/* Alert Message */}
                            <p className="text-sm text-slate-600 max-w-md mx-auto mb-6 leading-relaxed">
                                Download our mobile app to complete your video KYC seamlessly and verify your account.
                            </p>

                            {/* App Download Buttons */}
                            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
                                <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-full sm:w-auto px-6 py-3 bg-slate-900 text-white font-semibold text-xs rounded-xl hover:bg-slate-800 transition flex items-center justify-center gap-2 shadow-md"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                        <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734c0-.382.217-.728.609-.92zm11.3 11.3l2.3 2.3-10.8 6.1 8.5-8.4zm0-2.22l-8.5-8.4 10.8 6.1-2.3 2.3zm1.61 1.61l2.87-1.63c.63-.36.63-1.42 0-1.78l-2.87-1.63-2.12 2.12 2.12 2.12z"/>
                                    </svg>
                                    Get it on Google Play
                                </a>

                                <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-full sm:w-auto px-6 py-3 bg-slate-900 text-white font-semibold text-xs rounded-xl hover:bg-slate-800 transition flex items-center justify-center gap-2 shadow-md"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.33c.66-.8 1.11-1.92.99-3.03-.96.04-2.12.64-2.8 1.44-.61.71-1.14 1.86-1 2.96 1.08.08 2.16-.57 2.81-1.37z"/>
                                    </svg>
                                    Download on App Store
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}